import styled, { css } from 'styled-components';

import {
    Flex,
    Paragraph,
    spaceMixin,
    mediaMixin,
    token,
} from '@zillow/constellation';

const desktopTooltipBreakpoint = 'xxl';

export const StyledWideLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${token('colors.white')};
    max-width: 1280px;
    min-height: 550px;
    flex: 1;
`;

export const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;
    ${mediaMixin('lg', css`
       padding: ${spaceMixin('md')};
    `)};
`;

export const StyledContentContainer = styled(Flex)`
    min-height: 550px;
    min-width: 0;
    padding: ${spaceMixin('md')} ${spaceMixin('sm')};
    background-color: ${token('colors.white')};
    flex: 1;
    width: 100%;

    .transition-wrapper {
        height: 100%;
    }

    @media only screen and (min-height: 900px) {
        min-height: 640px;
    }

    ${mediaMixin('xl', css`
        border-radius: 4px;
        padding: ${spaceMixin('lg')};
    `)};
    
    ${mediaMixin(desktopTooltipBreakpoint, css`
        max-width: 712px;
        min-height: 610px;
        border-radius: 4px;
        padding: ${spaceMixin('md')};
    `)};
`;

export const StyledCenterParagraph = styled(Paragraph)`
    text-align: center;
`;

export const StyledDesktopTitleParagraph = styled(Paragraph)`
    text-align: center;
    ${mediaMixin('sm_lte', css`
        display: none;
    `)};
`;

export const StyledMobileTitleParagraph = styled(Paragraph)`
    text-align: center;
    ${mediaMixin('md', css`
        display: none;
    `)};
`;

export const StyledDescriptionContainer = styled.div`
    padding-top: ${spaceMixin('md')};
    margin: auto;
    width: 100%;
    ${mediaMixin('md', css`
        max-width: 470px;
    `)};
`;

export const StyledIcon = styled.div`
    height: 120px;
    width: 120px;
`;
